import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * Wraps a <Table> with horizontal scroll on small screens.
 * Prevents table overflow — all data tables should use this.
 *
 * Usage:
 *   <ScrollTable minWidth={600}>
 *     <Table>…</Table>
 *   </ScrollTable>
 */

interface ScrollTableProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Minimum table width in px before scrolling kicks in (default: 500) */
  minWidth?: number;
}

export function ScrollTable({
  minWidth = 500,
  className,
  children,
  ...props
}: ScrollTableProps) {
  return (
    <div className={cn('overflow-x-auto', className)} {...props}>
      <div style={{ minWidth }}>{children}</div>
    </div>
  );
}
